import Vue from 'vue'
export default {
    methods: {
        showNotifyWarning(msg, time){
            Vue.prototype.$vs.notify({
              title: "Atenção",
              text: msg,
              color: "warning",
              icon: 'error_outline',
              time: time,
              position: "top-right",
            });
          },
          showNotifyError(msg, time){
            Vue.prototype.$vs.notify({
              title: "Atenção",
              text: msg + ". Entre em contato com a equipe de atendimento para informar o ocorrido através do e-mail: contato@filoo.com.br ou pelo whatsapp 11 99650-7610.",
              color: "danger",
              click:()=>{
                window.open('https://api.whatsapp.com/send?phone=55011996507610&text=Sua%20mensagem%20aqui', '_blank');
              },
              time: time,
              icon: 'cancel',
              position: "top-right",
            });
          },
          showNotifySuccess(title, msg, time){
            Vue.prototype.$vs.notify({
              title: title,
              text: msg,
              color: "success",
              icon: 'verified_user',
              time: time,
              position: "top-right",
            });
          },
        maskMoney(value) {
            var formatter = new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2
            });
            var newValue = parseFloat(value);

            var newValueFormat = formatter.format(newValue);

            return newValueFormat;
        },
        maskPhone(__phone) {
            if (this.testNullUndefinedEmpty(__phone)) {
                return "Sem registro";
            } else {
                var pt = /[()\- ]+/gi
                __phone = __phone.replace(pt, '');
                __phone = '(' + __phone.substr(0, 2) + ') ' + __phone.substr(2, 5) + '-' + __phone.substr(6, 4);
                return __phone;
            }
        },
        maskCelPhone(v) {
            if (this.testNullUndefinedEmpty(v)) {
                return "Sem registro";
            } else {
                v = v.replace(/\D/g, "");
                v = v.replace(/^(\d{2})(\d)/g, "$1 $2");
                v = v.replace(/(\d)(\d{4})$/, "$1-$2");
                return v.substr(0, 15);
            }

        },
        maskZipcode(v) {
            if (this.testNullUndefinedEmpty(v)) {
                return "Sem registro";
            } else {
                v = v.replace(/D/g, "")
                v = v.replace(/^(\d{5})(\d)/, "$1-$2")
                return v
            }
        },
        /* eslint-disable */
        maskRg(v) {
            if (this.testNullUndefinedEmpty(v)) {
                return "Sem registro"
            } else {
                v = v.replace(/\D/g, "");
                v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4");
                return v;
            }
        },
        maskCpf(value) {
            if (this.testNullUndefinedEmpty(value)) {
                return "Sem registro";
            } else {
                return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
            }
        },
        maskCnpj(value) {
            if (this.testNullUndefinedEmpty(value)) {
                return "Sem registro";
            } else {
                return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
            }
        },
        validateEmail(mail) {
            if (/^.+@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(mail)) {
                return (true)
            }
            return (false)
        },
        testNullUndefinedEmpty(field) {
            if (field == "" || field == undefined || field == null)
                return true;
            else
                return false;
        },
        validateCreditCardNumber(number) {
            if (this.testNullUndefinedEmpty(number)) {
                return false;
            } else {
                let cardnumber = number.replace(/[^0-9]+/g, '');

                let cards = {
                    visa: /^4[0-9]{12}(?:[0-9]{3})/,
                    mastercard: /^5[1-5][0-9]{14}/,
                    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
                    amex: /^3[47][0-9]{13}/,
                    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
                    hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
                    elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
                    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
                    aura: /^(5078\d{2})(\d{2})(\d{11})$/
                };

                for (let flag in cards) {
                    if (cards[flag].test(cardnumber)) {
                        return flag;
                    }
                }

                return false;
            }
        },
        validateYearGraduation(number) {
            if (this.testNullUndefinedEmpty(number) || (number < 1900) || (number > (new Date().getFullYear() + 1))) {
                return false;
            } else {
                return true;
            }
        },
        testFullName(word) {
            const vm = this;
            if(vm.testNullUndefinedEmpty(word)){
                return false;
            } else {
                word = word.trimStart().trimEnd();
                let wordSplit = word.split(' ');
                return wordSplit.length > 1 && wordSplit[0] !='.' && wordSplit[1] !='.';
            }
        },
        testValidName(name){
          if(this.testNullUndefinedEmpty(name)){
            return false;
          } else {
            if(this.testFullName(name) == false){
              return false;
            }
            if(name.length < 5){
              return false;
            }
            if(name.trim().length == 0){
              return false;
            }
          }
          return true;
        },
        validateCPF(cpf) {
            if (cpf == null || cpf == undefined) return false;
            cpf = cpf.replace(/\D/g, '');
            if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
            var result = true;
            [9, 10].forEach(function (j) {
                var soma = 0,
                    r;
                cpf.split(/(?=)/).splice(0, j).forEach(function (e, i) {
                    soma += parseInt(e) * ((j + 2) - (i + 1));
                });
                r = soma % 11;
                r = (r < 2) ? 0 : 11 - r;
                if (r != cpf.substring(j, j + 1)) result = false;
            });
            return result;
        },
        validateCNPJ(cnpj) {
            if (this.testNullUndefinedEmpty(cnpj)) return false;
            cnpj = cnpj.toString().replace(/[^\d]+/g, '');


            if (cnpj.length != 14)
                return false;

            if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999")
                return false;

            var tamanho = cnpj.length - 2
            var numeros = cnpj.substring(0, tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;

            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) {
                return false;
            }

            return true;

        },
        maskMoneyWithoutStyle(value) {
            var formatter = new Intl.NumberFormat("pt-BR", {
                currency: "BRL",
                minimumFractionDigits: 2
            });
            var newValue = parseFloat(value);

            var newValueFormat = formatter.format(newValue);

            return newValueFormat;
        },
        formatDateTwo(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('/');
        },
        formatDateBr(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
            return [day, month, year].join("/");
        },
        formatDateToTypeDate(date) {
            const d = new Date(`${date} 01:00:000`),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            return [year, month, day].join('-');
        },
        formatDateBrToTypeDate(dateBr) {
            var splitDate = dateBr.split("/");
            var date = `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`;
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        formatDate(dateStr) {
            var dArr = null;
            dArr = dateStr.split("-");
            return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0);
        },
        formatDateHour(dateStr) {
            var dInit = null;
            var dArr = null;
            var dDate = null;
            var dHour = null;
            dInit = dateStr.split(" ");
            dDate = dInit[0];
            dHour = dInit[1];
            dArr = dDate.split("-");
            return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) + " " + dHour.substring(0, 5);
        },
        formatDateHourFromDate(date) {
            const day = date.toLocaleDateString('en-GB');
            const hour = date.toTimeString().split(" ")[0];
            return day + " " + hour;
        },
        trim(e) {
            var espacos = /\s/g;
            return e.replace(espacos, "");
        },
        round(value, exp) {
            if (typeof exp === "undefined" || +exp === 0) return Math.round(value);

            value = +value;
            exp = +exp;

            if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0))
                return NaN;

            value = value.toString().split("e");
            value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));

            value = value.toString().split("e");
            return +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp));
        },
        isHour(hour) {
            const vm = this;
            if (vm.testNullUndefinedEmpty(hour)) {
                return false;
            } else {
                let hourString = hour;
                if (hourString.length < 4) {
                    return false;
                }
                let hourArray = hour.split(":");
                let partOne = hourArray[0];
                let parttTwo = hourArray[1];
                let intPartOne = parseFloat(partOne);
                let intPartTwo = parseFloat(parttTwo);
                if (intPartOne > 23 || intPartTwo > 59) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        isDate(input) {
            var status = false;
            if (!input || input.length <= 0) {
                status = false;
            } else {
                var result = new Date(input);
                if (result == 'Invalid Date') {
                    status = false;
                } else {
                    status = result.getFullYear() > 9999 ? false : true;
                }
            }
            return status;
        },
        getDay(dateHour) {
            if (dateHour == undefined) {
                return ""
            }
            return dateHour.substring(0, 10);
        },
        getHour(dateHour) {
            if (dateHour === undefined) {
                return '';
            } else {
                return dateHour.substring(11, 16);
            }
        },
        getDayOfWeek(date1) {
            if (date1 == undefined) {
                return ""
            }
            var date = date1;
            if (date === undefined) {
                return '';
            } else {
                date = date.substring(0, 10);
                var parts = date.split("/");
                var dt = new Date(parseInt(parts[2], 10),
                    parseInt(parts[1], 10) - 1,
                    parseInt(parts[0], 10));

                var dayOfWeek = dt.getDay();
                return isNaN(dayOfWeek) ? null : ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'][dayOfWeek];
            }
        },
        validateBirthDate(date) {
            var dtDOB = new Date(date);
            if(this.isDate(dtDOB) && this.dateIsValidAndBeforeNow(date)) {
                var dtCurrent = new Date();
                var years = dtCurrent.getFullYear() - dtDOB.getFullYear();
                if (years == 18) {
                    var months = dtCurrent.getMonth() - dtDOB.getMonth();
                    if (months < 0) {
                        return false;
                    }
                    if (months == 0) {
                        if (dtCurrent.getDate() < dtDOB.getDate()) {
                            return false;
                        }
                    }
                    return true;
                } else {
                    return years > 18;
                }
            }
            return false;
        },
        validateZipCode(zipcode) {
            return !this.testNullUndefinedEmpty(zipcode) && /^[0-9]{5}-[0-9]{3}$/.test(zipcode);
        },
        dateIsValidAndBeforeNow(date) {
            return !this.testNullUndefinedEmpty(date) && new Date(date) <= new Date();
        },
        dateIsValidAndAfterNow(date) {
            return !this.testNullUndefinedEmpty(date) && new Date(date) >= new Date();
        },
        dateIsBeforeAnotherDate(date1, date2) {
            return new Date(date1) <= new Date(date2) || this.testNullUndefinedEmpty(date2);
        },
        validateDateFields(dateInitial, dateFinal) {
            let result = { invalidInitial:false, invalidFinal:false, disableButton:false};
            const isBefore = this.dateIsBeforeAnotherDate(dateInitial, dateFinal);
            result.invalidInitial = !this.testNullUndefinedEmpty(dateFinal) && !isBefore;
            result.invalidFinal = !this.testNullUndefinedEmpty(dateInitial) && !isBefore;
            result.disableButton = !!(this.isDate(dateInitial) ^ this.isDate(dateFinal))
            || result.invalidInitial || result.invalidFinal;
            return result;
        },
        checkMobile() {
            const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i]
            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem)
            })
        },
        getOnlyNumbers(value) {
          return value ? value.replace(/\D/g, "") : null;
        },
    },
}
